import React from 'react';
import _ from '@lodash';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import "../../../../styles/ag-grid-custom.css";


function ListView(props) {
	
	return (
			
			// <FuseScrollbars className="flex-grow overflow-x-auto">
		<div className="ag-theme-alpine tickets-grid" style={{ height: 400, width: "100%" }}>
			<AgGridReact
				domLayout="normal"
                        rowData={props.endUsersAccounts}
				onRowClicked={e => { if (props.gotoCompanyDetail) { props.gotoCompanyDetail(e.data.id) } }} columnDefs={[
					...Object.keys(props.endUsersAccounts[0])
						.filter((header) => header != 'id')
						.map((header) => {
							return {
								field: header,
								sortable: true,
								key: header,
								resizable: true,
								headerName: header.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' '),
							};
						})
				]}
			>
                    </AgGridReact>
                </div>
			// </FuseScrollbars>
			
	);

}

export default ListView
